import React from 'react';
import { config } from '../../config';
import { useProcessingItems } from '../../contexts/ProcessingItemsContext';
import { theme } from '../../theme';
import ProcessorColumn from '../molecules/columns/ProcessorColumn';
import ProcessorCardFactory from '../molecules/factories/ProcessorCardFactory';
import Box from '../ui/Box/Box';

/**
 * This component wraps the UI behind the processing tab. It has a column for every processingItem
 * and returns Card components from its Factory
 * @returns {JSX.Element}
 * @constructor
 */
const Processors = () => {
  const { processingItems } = useProcessingItems();
  const steps = Object.values(config.processingSteps);

  return (
    <Box style={{
      paddingLeft: theme.spacing['spacing-10'],
      paddingTop: theme.spacing['spacing-06'],
      height: window.innerHeight - 149,
      flexDirection: 'row',
      overflow: 'auto',
    }}>
      {/*{processingItems?.map((processingItem, i) => {*/}
      {/*  return (*/}
      {/*    <ProcessorColumn key={i} step={processingItem.step}>*/}
      {/*      <ProcessorCardFactory key={i} processingItem={processingItem}/>*/}
      {/*    </ProcessorColumn>);*/}
      {/*})}*/}

      {steps?.map((step, i) => {
        const stepItem = processingItems.find(item => item.step === step);
        console.log(stepItem);
        return (
          <ProcessorColumn key={i} step={step}>
            {stepItem && <ProcessorCardFactory key={i} processingItem={stepItem}/>}
          </ProcessorColumn>);
      })}
    </Box>
  );
};

export default Processors;
